import { makeObservable, observable, action } from 'mobx';

export default class RatingImgViewModel {
  @observable isPointAt = 0;
  @observable disabled = false;

  constructor(disabled) {
    makeObservable(this);

    this.init(disabled);
  }

  @action
  init = (disabled) => {
    this.disabled = disabled;
  }

  @action
  onMouseEnter = (number) => {
    if (this.disabled) {
      return;
    }
    this.isPointAt = number;
  }

  @action
  onMouseLeave = () => {
    if (this.disabled) {
      return;
    }
    this.isPointAt = 0;
  }
}
